<template>
  <div class="py-2">
    <v-slide-group
      class="border-radius"
      :style="error ? 'border: 1px solid #F44336' : 'border: 1px solid transparent'"
      v-bind="$attrs"
      :value="findValue()"
      @change="$emit('input', findOutput($event))"
      show-arrows
    >
      <v-slide-item
        v-for="(item, i) in items"
        :key="i"
        v-slot="{ active, toggle }"
        :disabled="$store.getters.isDisabled"
      >
        <v-card class="ma-4" width="120" elevation="0" tile>
          <v-card
            tile
            :elevation="active ? 8 : 1"
            @click="$store.getters.isDisabled ? undefined : toggle()"
            :color="item.color"
          >
            <v-img v-if="item.image" :src="item.image" aspect-ratio="1">
              <div class="d-flex h-100 flex-column align-space-between">
                <div class="d-flex justify-space-between">
                  <v-avatar color="white" size="24" class="ma-1 elevation-1">
                    <v-icon color="primary" v-if="active">mdi-check</v-icon>
                  </v-avatar>
                  <v-chip color="blue-grey darken-2" small dark class="ma-1" v-if="item.price_tag">
                    {{ item.price_tag }}
                  </v-chip>
                </div>
              </div>
            </v-img>
            <v-sheet v-else-if="item.color" height="120" :color="item.color">
              <div class="d-flex h-100 flex-column align-space-between">
                <div class="d-flex justify-space-between">
                  <v-avatar color="white" size="24" class="ma-1 elevation-1">
                    <v-icon color="primary" v-if="active">mdi-check</v-icon>
                  </v-avatar>
                  <v-chip color="blue-grey darken-2" small dark class="ma-1" v-if="item.price_tag">
                    {{ item.price_tag }}
                  </v-chip>
                </div>
              </div>
            </v-sheet>
          </v-card>
          <div class="mt-1" style="line-height: 1.1">
            <div v-if="item.title">
              <small>{{ item.title }}</small>
            </div>
            <div v-if="item.subtitle" class="text--disabled">
              <small>{{ item.subtitle + " " }}</small>
            </div>
          </div>
        </v-card>
      </v-slide-item>
    </v-slide-group>
    <div v-if="error" class="mx-2 mb-2 d-flex align-center">
      <div>
        <v-icon color="error">mdi-exclamation</v-icon>
      </div>
      <div>
        <div v-if="Array.isArray(errorMessages)">
          <div v-for="(message, i) in errorMessages" :key="i">
            <small class="error--text">{{ errorMessages }}</small>
          </div>
        </div>
        <div v-else>
          <small class="error--text">{{ errorMessages }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },

    error: {
      type: Boolean,
      default: false,
    },

    errorMessages: {
      type: [String, Array],
      default: null,
    },

    /**
     * If null or "index", then index of option is used.
     */
    valueField: {
      type: String,
      default: "slug",
    },

    items: {
      type: Array,
      default: () => [
        {
          slug: "some-slug",
          image: "/path/to/image.jpg",
          title: "Item Title",
          subtitle: "Description",
          color: "#FFE5AA",
          price_tag: "25 €",
        },
      ],
    },
  },

  computed: {
    useIndex() {
      return !this.valueField || this.valueField === "index";
    },
  },

  methods: {
    /**
     * Find the index for slide group's value field
     */
    findValue() {
      if (this.useIndex) return this.value;
      return this.findIndex(this.value);
    },

    findIndex(value) {
      if (value !== 0 && !value) return null;
      return this.items.findIndex((item) => item[this.valueField] === value);
    },

    /**
     * Find the outpout value ([index, slug, id, ...] of selected option)
     */
    findOutput(index) {
      if (this.useIndex) return index;

      if (!index && index !== 0) return null;
      return this.items[index][this.valueField];
    },
  },
};
</script>
